export default "__VITE_ASSET__DsIScAn3__"